import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TAB_INDEX } from '../../pages/GeneracionArchivosSRT/Index';

export const removeSRTCodeFromErrors = (
  data: PresentationUploadErrorLocationData,
  srtCodeToRemove: string
): PresentationUploadErrorLocationData => {
  if (!data) return null;

  const updated: PresentationUploadErrorLocationData = {};

  for (const [cuit, codes] of Object.entries(data)) {
    if (!codes) continue; // 🛡️ skip undefined/null arrays

    const filteredCodes = codes.filter(code => code !== srtCodeToRemove);
    if (filteredCodes.length > 0) {
      updated[cuit] = filteredCodes;
    }
  }

  return Object.keys(updated).length > 0 ? updated : null;
};

type PresentationUploadErrorLocationData = Partial<Record<string, string[]>> | null;

interface InitialState {
  presentationUploadErrorLocationData: PresentationUploadErrorLocationData;
  currentTab: TAB_INDEX;
}

const initialState: InitialState = {
    presentationUploadErrorLocationData: null,
    currentTab: TAB_INDEX.RGRL
};

const srtPresentationsSlice = createSlice({
    name: 'srtPresentations',
    initialState,
    reducers: {
        setPresentationUploadErrorLocationData: (
            state,
            action: PayloadAction<PresentationUploadErrorLocationData>
        ) => {
            state.presentationUploadErrorLocationData = action.payload;
        },
        clearPresentationUploadErrorLocationData: (state) => {
            state.presentationUploadErrorLocationData = null;
        },
        setCurrentFileGenerationTab: (state, action: PayloadAction<TAB_INDEX>) => {
          state.currentTab = action.payload;
        }
    }
});

export const { setPresentationUploadErrorLocationData, clearPresentationUploadErrorLocationData, setCurrentFileGenerationTab } =
  srtPresentationsSlice.actions;
export default srtPresentationsSlice.reducer;
